import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { BaseFormMobileComponent } from '../../../base-components';
import { removeCharacters } from '@foxeet/utils/*';

@Component({
  selector: 'ui-mobile-form-input-textarea',
  templateUrl: './form-input-textarea.component.html',
  styleUrls: ['./form-input-textarea.component.scss'],
})
export class FormInputTextAreaComponent extends BaseFormMobileComponent implements OnInit {
  @Input() autoGrow = true;
  @Input() cssClass?: string;
  @Input() canEmitOnBlur = true;
  @Output() controlEmitter = new EventEmitter<boolean>();

  loaded = false;

  ngOnInit() {
    super.ngOnInit();

    /**
     * @description bug: Autogrow property in IonTextArea doesnt look good #21242
     * @see https://github.com/ionic-team/ionic-framework/issues/21242
     * @status Open
     */
    setTimeout(() => {
      this.loaded = true;
    }, 250);

    this.control.valueChanges.pipe(takeUntil(this._componentDestroyed)).subscribe((el) => {
      this.controlEmitter.emit(true);
    });
  }

  /**
   * Detecta cuando se pega texto (CTRL+V) en el textarea
   * @param event Evento de pegado
   */
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    // Prevenir el comportamiento predeterminado del navegador
    event.preventDefault();

    const input = event.target as HTMLInputElement;

    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text') ?? '';
    const cleanedText = removeCharacters(pastedText);

    const start = input.selectionStart ?? undefined;
    const end = input.selectionEnd ?? undefined;

    const originalValue = input.value;
    const newValue = originalValue.slice(0, start) + cleanedText + originalValue.slice(end);

    input.value = newValue;
    this.control.setValue(newValue);

    const newPos = start + cleanedText.length;
    input.setSelectionRange(newPos, newPos);
  }

  /** **** */
}
